import * as React from 'react';
import styles from './RadioButton.module.scss';
import clsx from 'clsx';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  title?: string;
  value?: string | number;
  inputClassname?: string;
  testId?: string;
};

export const RadioButton = React.forwardRef<HTMLInputElement, Props>(
  function RadioButton(props, ref) {
    const { title, inputClassname, testId, ...rest } = props;
    const id =
      props.id ?? props.name != undefined
        ? `uni-radio-${props.name}-${props.value}`
        : undefined;
    return (
      <div className={clsx(styles.rowContainer, props.className)}>
        <input
          data-test-id={testId}
          type="radio"
          ref={ref}
          {...rest}
          id={id}
          className={clsx(styles.radio, inputClassname)}
        />
        <label className={styles.label} htmlFor={id}>
          {title}
        </label>
      </div>
    );
  },
);
